module.exports = __webpack_public_path__ + "images/company_profile/icon_en08-9a2b7bf9666cea2c9f76e212dfd6975d.png";